module.exports = __webpack_public_path__ + "img/places-5.e8f3441b.jpg";